// extracted by mini-css-extract-plugin
export default {"ctaContainer":"VehicleCategory_ctaContainer__SUL-e","nextCta":"VehicleCategory_nextCta__2neir","catContainer":"VehicleCategory_catContainer__I0-pi"};